import RelacioanalizisesKerdesTableService from 'app/admin/relacioanaliziseskerdes/service/RelacioanalizisesKerdesTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'relacioanalizisesKerdesTable',
	text: 'Relációanalízises kérdés',
	textKey: 'question',
	service: RelacioanalizisesKerdesTableService,
	icon: 'person',
	editFormState: item => `/relacioanaliziseskerdes/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	// rowEndAction: ['subPage', 'modify'],
	// rowClick: item => `/valasz/${item.id}`,
	// subPage: {
	// 	state: '/valasz/',
	// 	tooltip: 'Tartalom'
	// },
	filterFields: [
		{
			propertyName: 'csorszam',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			propertyName: 'feladatCsoport',
			propertyType: 'Long',
			type: 'IN'
		},
		{
			propertyName: 'fejezet',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        {
			key: 'leirasPlaintext',
			text: 'Leírás',
			textKey: 'leirasPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        {
			key: 'magyarazatPlaintext',
			text: 'Magyarázat',
			textKey: 'magyarazatPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function RelacioanalizisesKerdesTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('relacioanalizisesKerdesTable', reducer('relacioanalizisesKerdesTable'))(RelacioanalizisesKerdesTable);
